(function ($) {
  'use strict';

  const templateName = document.body.dataset.templateName || '';
  const bodyClasses = document.body.className || '';

  // Only run on women-belts product template
  if (
    !templateName.includes('women-belts') &&
    !bodyClasses.includes('women-belts')
  ) {
    return;
  }

  function initWomenBeltsGallery() {
    const root = document.querySelector('.halo-productView-left');
    if (!root) return;

    const nav = root.querySelector('[data-image-gallery-main]');
    const thumbs = root.querySelector('.productView-for');
    const wrapper = root.querySelector('.productView-thumbnail-wrapper');

    if (!nav || !thumbs || !wrapper) return;

    // Thumbnail wrapper positioning
    Object.assign(wrapper.style, {
      width: '123px',
      minWidth: '123px',
      maxWidth: '123px',
      flex: '0 0 123px',
      position: 'relative',
      top: '80.52px',
      opacity: '1',
      visibility: 'visible'
    });

    // Prevent duplicate event handlers
    $(thumbs).off('click.lrnWomenBeltsGallery');

    // Thumbnail click → matching main image
    $(thumbs).on(
      'click.lrnWomenBeltsGallery',
      '.productView-thumbnail',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const thumbId = this.getAttribute('data-media-id') || '';
        const mediaId = thumbId.split('-').pop();

        const slides = [
          ...nav.querySelectorAll('.productView-image')
        ];

        const target = slides.find(function (slide) {
          const image = slide.querySelector('[data-media-id]');
          return image &&
            image.getAttribute('data-media-id') === mediaId;
        });

        if (!target) {
          console.warn('Matching gallery image not found:', mediaId);
          return;
        }

        slides.forEach(function (slide) {
          slide.style.setProperty('display', 'none', 'important');
        });

        target.style.setProperty('display', 'inline-block', 'important');

        thumbs
          .querySelectorAll('.productView-thumbnail')
          .forEach(function (thumb) {
            thumb.classList.remove('is-active');
          });

        this.classList.add('is-active');

        const counter = root.querySelector('#count-image');

        if (counter) {
          counter.textContent = String(slides.indexOf(target) + 1);
        }
      }
    );

    // Floating thumbnail arrows — Handbags implementation
    createFloatingThumbnailArrows(wrapper, thumbs);
  }

  function createFloatingThumbnailArrows(wrapper, thumbs) {
    // Remove old floating arrows
    document.querySelectorAll('.lrn-floating-thumb-arrow').forEach(function (btn) {
      btn.remove();
    });

    // Remove previous listeners
    if (wrapper._lrnArrowPositionHandler) {
      window.removeEventListener(
        'scroll',
        wrapper._lrnArrowPositionHandler,
        true
      );

      window.removeEventListener(
        'resize',
        wrapper._lrnArrowPositionHandler
      );
    }

    function createArrow(direction) {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'lrn-floating-thumb-arrow lrn-floating-thumb-arrow-' + direction;
      button.setAttribute(
        'aria-label',
        direction === 'up' ? 'Previous thumbnails' : 'Next thumbnails'
      );

      button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             width="14px"
             height="14px"
             style="transform: rotate(${direction === 'up' ? '-90deg' : '90deg'});">
          <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"
                fill="currentColor"></path>
        </svg>
      `;

      Object.assign(button.style, {
        position: 'fixed',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        border: 'none',
        background: 'transparent',
        color: '#000',
        boxShadow: 'none',
        cursor: 'pointer',
        zIndex: '99999'
      });

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (typeof $(thumbs).slick !== 'function') return;

        try {
          $(thumbs).slick(
            direction === 'up' ? 'slickPrev' : 'slickNext'
          );
        } catch (error) {
          console.warn('Thumbnail slider navigation unavailable:', error);
        }
      });

      document.body.appendChild(button);

      return button;
    }

    const up = createArrow('up');
    const down = createArrow('down');

    function positionArrows() {
      const rect = wrapper.getBoundingClientRect();
      const center = rect.left + rect.width / 2;

      up.style.left = `${center - 16}px`;
      up.style.top = `${rect.top - 38}px`;

      down.style.left = `${center - 16}px`;
      down.style.top = `${rect.bottom + 6}px`;
    }

    wrapper._lrnArrowPositionHandler = positionArrows;

    window.addEventListener('scroll', positionArrows, true);
    window.addEventListener('resize', positionArrows);

    positionArrows();
    requestAnimationFrame(positionArrows);
  }

  // Responsive product details CSS
  function addWomenBeltsStyles() {
    if (document.getElementById('lrn-women-belts-styles')) return;

    const style = document.createElement('style');
    style.id = 'lrn-women-belts-styles';

    style.textContent = `
      @media screen and (min-width: 1600px) and (max-width: 1940px) {

        /* PRODUCT DETAILS WIDTH */
        .productView-details,
        .productView-info {
          width: 550px !important;
          max-width: 550px !important;
          flex: 0 0 550px !important;
          margin-left: auto !important;
          margin-right: auto !important;
        }

        /* VARIANT SIZE BUTTON */
        .productView-details .product-form__input label,
        .productView-details .productView-size .variant-item,
        .productView-details .productView-size .swatch-element,
        .productView-details .product-form__label {
          width: auto !important;
          min-width: auto !important;
          height: 44px !important;
          display: inline-flex !important;
          justify-content: center !important;
          align-items: center !important;
          text-align: center !important;
          padding: 0 !important;
          line-height: 46px !important;
        }

        .product-form__label .text {
          width: auto !important;
          min-width: auto !important;
          height: 44px !important;
        }

        /* PRODUCT TITLE */
        .productView-title {
          font-size: 32px !important;
          line-height: 1.3 !important;
        }

        /* ADD TO CART */
        .productView-details button[name="add"],
        .productView-details .product-form__submit,
        .productView-details .product-form__cart-submit {
          display: block !important;
          width: 100% !important;
          min-width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
          text-align: center !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function init() {
    addWomenBeltsStyles();
    initWomenBeltsGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinitialize after Shopify section reloads
  document.addEventListener('shopify:section:load', init);

})(window.jQuery);